/**
 * RBAC permission names — aligned with backend Permissions enum and RBAC_Permission_Role_UI_Matrix.csv.
 * Use with usePermissions(): hasPermission(Permission.viewJobs)
 */
export const Permission = {
    // Jobs
    viewJobs: "viewJobs",
    createJob: "createJob",
    updateJob: "updateJob",
    publishJob: "publishJob",
    deleteJob: "deleteJob",
    deactivateJob: "deactivateJob",
    shareJob: "shareJob",
    manageCampaign: "manageCampaign",

    // Rounds
    viewRounds: "viewRounds",
    createRound: "createRound",
    updateRound: "updateRound",
    deleteRound: "deleteRound",
    manageCriteria: "manageCriteria",

    // Agents
    viewAgent: "viewAgent",
    testAgent: "testAgent",

    // Candidates
    viewCandidates: "viewCandidates",
    createCandidate: "createCandidate",
    updateCandidate: "updateCandidate",
    commentCandidate: "commentCandidate",
    rejectCandidate: "rejectCandidate",
    moveCandidate: "moveCandidate",
    reEvaluateCandidate: "reEvaluateCandidate",
    updateCandidateData: "updateCandidateData",
    reAttemptCandidate: "reAttemptCandidate",
    viewRetakes: "viewRetakes",
    manageRetakes: "manageRetakes",
    downloadFile: "downloadFile",

    // Bulk
    viewBulkJobs: "viewBulkJobs",
    createBulkJob: "createBulkJob",

    // Clients
    viewClients: "viewClients",
    createClient: "createClient",
    updateClient: "updateClient",

    // Billing
    viewBilling: "viewBilling",
    manageBilling: "manageBilling",

    // User management
    viewUserManagementPage: "viewUserManagementPage",
    viewUserManagementAllUsersTab: "viewUserManagementAllUsersTab",
    viewUserManagementUserRolesTab: "viewUserManagementUserRolesTab",
    createWorkspaceUser: "createWorkspaceUser",
    updateWorkspaceUser: "updateWorkspaceUser",
    addUsersToWorkspace: "addUsersToWorkspace",
    viewRolePermissions: "viewRolePermissions",
    manageRolePermissions: "manageRolePermissions",

    // Workspace
    viewWorkspaceConfig: "viewWorkspaceConfig",

    // Files
    uploadFile: "uploadFile",

    // Workflows / documents
    manageWorkflows: "manageWorkflows",
    generatePdf: "generatePdf",

    // Platform / internal
    manageSecretEndpoint: "manageSecretEndpoint",
    bulkResetPassword: "bulkResetPassword",
} as const

export type Permission = (typeof Permission)[keyof typeof Permission]

export const PERMISSION_VALUES = Object.values(Permission) as Permission[]

export function isPermission(value: string): value is Permission {
    return (PERMISSION_VALUES as string[]).includes(value)
}
